/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {configureAdminResourceStates} from '../common/controller/admin-resource-routing';
import {PrintLineItemResource} from '../../components/api/resources/resource/print-line-item.resource';


export function printLineItemStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('print-line-items.print-line-item', PrintLineItemResource, 'app.adv', 'app');
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'PrintLineItem',
          editTag: 'adn-print-line-item-edit-page',
          listTag: 'adn-print-line-item-list-page',
          crumbParams: [{type: 'Advertiser'}]
        });
  }, adnRouterHelper);
}
